import React from "react"

const EmbedYoutube = ({ src }) => {
  return (
    <div class="text-center">
      <iframe
        width="560"
        height="315"
        src={src}
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
        style={{ maxWidth: "100%" }}
        title="Music video embedded from YouTube"
      ></iframe>
    </div>
  )
}

export default EmbedYoutube
